var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1713_5004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5001 1.75C8.9001 1.75 10.9001 3.75 10.9001 6.15C10.9001 8.55 8.9001 10.55 6.5001 10.55C4.1001 10.55 2.1001 8.55 2.1001 6.15C2.1001 3.75 4.1001 1.75 6.5001 1.75ZM6.5001 0.25C3.2001 0.25 0.600098 2.85 0.600098 6.15C0.600098 9.45 3.2001 12.05 6.5001 12.05C9.8001 12.05 12.4001 9.45 12.4001 6.15C12.4001 2.85 9.8001 0.25 6.5001 0.25Z",
    fill: "#DDE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 13.75L9.90015 9.65002",
    stroke: "#DDE9F4",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1713_5004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4,
    height: 13.5,
    fill: "white",
    transform: "translate(0.600098 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/IconSearch.1d070f4282cbfbb9a6ba548c7834bb71.svg";
export { ForwardRef as ReactComponent };